const securityFeatures = [
  {
    icon: 'ri-user-unfollow-line',
    title: 'Maskeli İsim Yapısı',
    desc: 'Terapistlerin tam isimleri gizlenir. Sadece baş harfler ve kontrollü tanımlayıcı bilgiler görünür.',
  },
  {
    icon: 'ri-phone-lock-line',
    title: 'Telefon ve Instagram Gizliliği',
    desc: 'Telefon numarası, Instagram ve diğer sosyal medya hesapları profilde yer almaz.',
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'İlçe / Açık Adres Gizliliği',
    desc: 'Açık adres ve ilçe bilgileri sadece çift taraflı onay sonrası paylaşılır.',
  },
  {
    icon: 'ri-filter-3-line',
    title: 'Chat İçi İletişim Bilgisi Filtresi',
    desc: 'Platform chat içinde telefon, e-posta ve diğer iletişim bilgileri otomatik filtrelenebilir.',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Admin Chat Erişimi',
    desc: 'Şikayet olmadan admin chat içeriğini okuyamaz. Gizlilik tamamen korunur.',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Etik Dışı Teklif Moderasyonu',
    desc: 'Etik dışı teklif ve davranışlara karşı ağır moderasyon ve anında hesap askıya alma.',
  },
];

export default function SecuritySection() {
  return (
    <section id="guvenlik" className="w-full bg-white py-14 md:py-20 lg:py-24">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center mb-10 md:mb-14">
            <div>
              <span className="inline-block px-3 py-1 bg-deep-navy-100 text-deep-navy-400 text-xs font-semibold rounded-full mb-4">
                Güvenlik ve Gizlilik
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-deep-navy-500 leading-tight mb-4">
                Güvenlik ve gizlilik platformun <span className="text-dark-teal-500">merkezinde</span>
              </h2>
              <p className="text-sm md:text-base text-gray-500 leading-relaxed">
                Telefon, WhatsApp, Instagram ve açık adres gibi bilgiler çift taraflı onay olmadan paylaşılmaz. Her adımda gizlilik ve güvenlik ön plandadır.
              </p>
            </div>
            <div className="hidden lg:block">
              <div className="relative w-full aspect-[4/3] bg-off-white rounded-2xl border border-gray-100 overflow-hidden">
                {/* Decorative security illustration */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-32 h-32 rounded-full bg-dark-teal-50 flex items-center justify-center">
                    <div className="w-20 h-20 rounded-full bg-dark-teal-100 flex items-center justify-center">
                      <div className="w-12 h-12 rounded-full bg-dark-teal-500 flex items-center justify-center">
                        <i className="ri-shield-check-line text-white text-2xl" />
                      </div>
                    </div>
                  </div>
                </div>
                {/* Orbiting dots */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-48 h-48 rounded-full border border-dashed border-gray-200 animate-spin" style={{ animationDuration: '20s' }}>
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-soft-gold-500" />
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-64 h-64 rounded-full border border-dashed border-gray-100 animate-spin" style={{ animationDuration: '30s', animationDirection: 'reverse' }}>
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-2 h-2 rounded-full bg-dark-teal-300" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {securityFeatures.map((f) => (
              <div
                key={f.title}
                className="group p-5 md:p-6 bg-off-white rounded-2xl border border-gray-100 hover:border-dark-teal-200 hover:shadow-soft transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-deep-navy-50 flex items-center justify-center mb-4 group-hover:bg-deep-navy-500 transition-colors duration-300">
                  <i className={`${f.icon} text-deep-navy-400 text-lg group-hover:text-white transition-colors duration-300`} />
                </div>
                <h3 className="text-base font-semibold text-deep-navy-500 mb-2">{f.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}